<template>
  <div>
    <div class="row justify-content-center my-3">
      <div class="col-10">
        <div class="row">
          <div v-if="filterCampaign" class="col-4">
            <h3>
              Campaña Actual: <span class="font-weight-normal">{{ filterCampaign.name }}</span>
            </h3>
          </div>
          <div v-if="distributor" class="col-4">
            <h3>
              Distribuidor: <span class="font-weight-normal">{{ distributor.name }}</span>
              <span class="clean-search px-2" @click="cleanDistributor"><i class="fa fa-times"></i></span>
            </h3>
          </div>
          <div v-if="filterCrop" class="col-4">
            <h3>
              Cultivo: <span class="font-weight-normal">{{ filterCrop.name }}</span>
            </h3>
          </div>
          <div v-if="filterVariety" class="col-4">
            <h3>
              Variedad: <span class="font-weight-normal">{{ filterVariety.name }}</span>
            </h3>
          </div>
          <div v-if="month" class="col-4">
            <h3>
              Mes: <span class="font-weight-normal">{{ month }}</span>
            </h3>
          </div>
        </div>
      </div>
      <div class="col-2">
        <button
          v-if="!disableReset"
          class="btn base-button btn-outline-primary btn-sm d-inline-block float-right"
          @click="resetFilters"
        >
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ActiveFilter',

  props: {
    crop: {
      type: [Number, String],
      default: null,
    },

    variety: {
      type: [Number, String],
      default: null,
    },

    month: {
      type: [Number, String],
      default: null,
    },

    distributor: {
      type: [Object],
      default: null,
    },

    disableReset: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      filterCrop: null,
      filterVariety: null,
      filterCampaign: null,
    };
  },

  computed: {
    ...mapState('navigation', {
      campaignId: (state) => state.campaignId,
    }),
  },

  created() {
    if (this.crop) {
      this.getCrop();
    }
    if (this.variety) {
      this.getVariety();
    }
    if (this.campaignId) {
      this.getCampaign();
    }
  },

  methods: {
    getCrop() {
      this.$services
        .resource('crops')
        .show(this.crop)
        .then(({ data }) => data.data)
        .then((crop) => (this.filterCrop = crop));
    },

    getVariety() {
      this.$services
        .resource('varieties')
        .show(this.variety)
        .then(({ data }) => data.data)
        .then((variety) => (this.filterVariety = variety));
    },

    getCampaign() {
      this.$services
        .resource('campaigns')
        .show(this.campaignId)
        .then(({ data }) => data.data)
        .then((campaign) => (this.filterCampaign = campaign));
    },

    cleanDistributor() {
      this.$emit('resetDistributor');
    },

    resetFilters() {
      this.$emit('reset');
    },
  },
};
</script>
